import React, { useState, useEffect, useCallback, useRef } from 'react';
import { gradeHex, pctGrade } from '../../utils/grades';
import { distNm, crossTrackFt, bearing } from '../../utils/geo';

function ScoreRing({ score, max, size = 64, strokeWidth = 5, label }) {
  const pct = max > 0 ? (score / max) * 100 : 0;
  const grade = pctGrade(pct);
  const color = gradeHex(grade);
  const r = (size - strokeWidth) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ * (1 - pct / 100);

  return (
    <div style={{ textAlign: 'center' }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="var(--border)" strokeWidth={strokeWidth} />
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={strokeWidth}
          strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.8s ease' }} />
      </svg>
      <div style={{ marginTop: -size/2 - 8, position: 'relative', fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: size * 0.22, color }}>
        {score}/{max}
      </div>
      <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginTop: size * 0.25, fontWeight: 500 }}>{label}</div>
    </div>
  );
}


export { ScoreRing };
